// extracted by mini-css-extract-plugin
export default {"container":"Poster_container__bChUc","mainposterbg":"Poster_mainposterbg__NE7+R","inside":"Poster_inside__2RkgI","mobbg":"Poster_mobbg__O95nU"};